import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyPl = () => {
    return <SupportPrivacyPolicy languageCode="pl" />
}

export default SupportPrivacyPolicyPl
